"use client";

import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
export default function EditorialPageHeader() {
  return <section id="editorialpageheader" className="bg-creme text-brun py-24 md:py-32 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.2,
          ease: [0.22, 1, 0.36, 1]
        }} className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg rounded-br-[120px]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/about_portrait.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/about_portrait.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/about_portrait.webp-wvc-sizes" alt="Portrait de la fondatrice de SLOW MAMA" className="w-full h-full object-cover" loading="lazy" src="https://quality-chicken.10web.cloud/wp-content/uploads/2026/06/image00001-1.webp" />
              <div className="absolute bottom-8 right-8 flex flex-col gap-2 items-end">
                <Badge className="bg-caramel text-off-white border-none px-4 py-1 rounded-lg shadow-md">
                  Doula
                </Badge>
                <Badge className="bg-terracotta text-off-white border-none px-4 py-1 rounded-lg shadow-md">
                  Postnatal
                </Badge>
              </div>
            </div>
          </motion.div>

          {}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.2,
          ease: [0.22, 1, 0.36, 1],
          delay: 0.2
        }} className="lg:col-span-7 flex flex-col gap-6">
            <div className="flex items-center gap-4">
              <span className="font-sans text-xs font-semibold tracking-widest text-caramel uppercase">ACCOMPAGNANTE POSTNATALE CERTIFIÉ LE MOIS D'OR</span>
              <div className="h-px w-10 bg-beige" />
            </div>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight text-brun">Là, pour te soutenir, mama.</h1>

            <div className="space-y-4">
              <h2 className="font-sans text-xl md:text-2xl font-bold text-brun">Isabel Roulet, fondatrice de SLOW MAMA</h2>
              <p className="font-sans text-lg text-brun/80 font-light leading-relaxed">Spécialiste de l'accompagnement postnatal&nbsp; Genève et sur La Côte.</p>
            </div>

            <div className="mt-4 relative">
              <div className="absolute -left-4 top-0 text-4xl font-serif text-terracotta opacity-40">
                &ldquo;
              </div>
              <p className="font-sans text-lg md:text-xl text-brun italic leading-relaxed pl-4 border-l border-beige">
                Mon propre post-partum m’a montré à quel point le soutien des mères est essentiel. Aujourd'hui, je mets mon expertise au service de votre bien-être pour une transition vers la maternité tout en douceur.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}